/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_APPLY = gql`
  mutation candidateApplicationApply($applications: [CandidateApplicationApplyInput!]) {
    candidate {
      applications(apply: $applications) {
        applications {
          bearerToken
          id
        }
        errors
        validations
      }
    }
  }
`;
